import { HeadingItem } from 'components';
import { ItemDetailInfo } from 'components/item-verification';
import { TripContext } from 'contexts';
import React, { FC, useContext } from 'react';
import { Company, Order, Stop, Trip } from 'services/types';
import dateFormat from "dateformat";
import './supplier-pickup-card.scss';

type Props = {
    orderId: number
}

export const SupplierPickupCard: FC<Props> = ({ orderId }) => {

    const tripContext = useContext(TripContext)
    const order: Order = tripContext.orders.find(o => o.id === orderId) ?? {} as Order
    const company: Company = tripContext.companies.find(c => c.id === order.soldToId) ?? {} as Company
    const stop: Stop = tripContext.stops.find(s => s.id === order.stopId) ?? {} as Stop
    const trip: Trip = tripContext.trips.find(t => t.id === stop.tripId) ?? {} as Trip

    const formattedExpectancyDate: string | undefined = dateFormat(order.expectancyDate!, 'mm/dd hh:MMtt')?.toString() ?? 'N/A'
    const formattedCityState: string | undefined = (company?.city != null && company?.state != null) ? `${company.city}, ${company.state}` : 'N/A'
    
    return (
        <div className={'card-material'}>
            <HeadingItem text={(`PO : ${order.orderNumber}` ?? 'Unknown Item')} />
            <div className={'item-verification-details-id-info'}>
                <ItemDetailInfo title={'Pickup / Release No'} value={order.releaseNumber ?? 'N/A'} />
                <ItemDetailInfo title={'Expectancy Date'} value={formattedExpectancyDate} />
                <ItemDetailInfo title={'Final Destination'} value={formattedCityState} />
                <ItemDetailInfo title={'Trailer Number'} value={trip.trailerId ?? 'N/A'} />
            </div>
            <div className={'item-verification-details-info-box'}>
                <div className={'bottom-left-box-info'}>
                    <ItemDetailInfo title={'Temp'} value={order.temperature} />
                    <ItemDetailInfo title={'Pallet'} value={order.totalPallets} />
                    <ItemDetailInfo title={'Items'} value={order.totalItems} />
                </div>
                <div className={'bottom-right-box-info'}>
                    <ItemDetailInfo title={'Weight'} value={order.totalWeight} />
                    <ItemDetailInfo title={'Cubes'} value={order.totalCube} />
                    <ItemDetailInfo title={'Pieces'} value={order.totalPieces} />
                </div>
            </div>
        </div>
    )
}
